import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { paymentRoutes } from './routes';
export class Report {
  constructor() {
    _defineProperty(this, "routes", paymentRoutes);
  }
  async downloadPropertyReport(data, options) {
    const resp = await requestService('payment').get(this.routes.download(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp;
  }
  async downloadCombinedPropertiesReport(data, options) {
    const resp = await requestService('payment').post(this.routes.downloadARCombined, data.propertyIds, _objectSpread({}, options.cancelToken));
    return resp;
  }
  async getPropertiesARReports(data, options) {
    const resp = await requestService('payment').post(this.routes.accountReceivable, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyReport(data, options) {
    const resp = await requestService('payment').get(this.routes.accountReceivableByPropertyId(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getReimbursement(data, options) {
    const PropertyIds = data.PropertyIds,
      UnitIds = data.UnitIds,
      Years = data.Years,
      Months = data.Months,
      UtilityTypeIds = data.UtilityTypeIds,
      ChargeTypes = data.ChargeTypes;
    const resp = await requestService('aggregate').post(this.routes.reimbursmentFilters + "".concat(!!(PropertyIds !== null && PropertyIds !== void 0 && PropertyIds.length) || !!(UnitIds !== null && UnitIds !== void 0 && UnitIds.length) || !!(Years !== null && Years !== void 0 && Years.length) || !!(Months !== null && Months !== void 0 && Months.length) || !!(UtilityTypeIds !== null && UtilityTypeIds !== void 0 && UtilityTypeIds.length) || !!(ChargeTypes !== null && ChargeTypes !== void 0 && ChargeTypes.length) ? '?' : '') + "".concat(PropertyIds !== null && PropertyIds !== void 0 && PropertyIds.length ? PropertyIds.map(n => "PropertyIds=".concat(n)).join('&') + '&' : '') + "".concat(UnitIds !== null && UnitIds !== void 0 && UnitIds.length ? UnitIds.map(n => "UnitIds=".concat(n)).join('&') + '&' : '') + "".concat(Years !== null && Years !== void 0 && Years.length ? Years.map(n => "Years=".concat(n)).join('&') + '&' : '') + "".concat(Months !== null && Months !== void 0 && Months.length ? Months.map(n => "Months=".concat(n)).join('&') + '&' : '') + "".concat(UtilityTypeIds !== null && UtilityTypeIds !== void 0 && UtilityTypeIds.length ? UtilityTypeIds.map(n => "UtilityTypeIds=".concat(n)).join('&') + '&' : '') + "".concat(ChargeTypes !== null && ChargeTypes !== void 0 && ChargeTypes.length ? ChargeTypes.map(n => "ChargeTypes=".concat(n)).join('&') + '&' : ''), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async sendReport(data, options) {
    const resp = await requestService('payment').post(this.routes.sendReport, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getReimbursementReport(body, options) {
    const resp = await requestService('payment').post(this.routes.reimbursmentReport, _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getReimbursementReportV2(body, options) {
    const resp = await requestService('payment').post(this.routes.reimbursmentReportV2, _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getReimbursementSlimReport(body, options) {
    const resp = await requestService('payment').post(this.routes.reimbursmentReportSlim, _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getReimbursementReceipt(data, options) {
    const resp = await requestService('payment').get("".concat(this.routes.reimbursementReceipt(data.propertyId), "?year=").concat(data.year, "&month=").concat(data.month), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getReimbursementReceiptPeriods(data, options) {
    var _data$monthsBack;
    const resp = await requestService('payment').get("".concat(this.routes.reimbursementReceiptPeriods(data.propertyId), "?monthsBack=").concat((_data$monthsBack = data.monthsBack) !== null && _data$monthsBack !== void 0 ? _data$monthsBack : 12), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async downloadReimbursementReceipt(data, options) {
    const resp = await requestService('payment').get("".concat(this.routes.reimbursementReceiptDownload(data.propertyId), "?year=").concat(data.year, "&month=").concat(data.month), _objectSpread({
      responseType: 'blob'
    }, options.cancelToken));
    return resp;
  }
  async downloadChargeExport(data, options) {
    const resp = await requestService('payment').get("".concat(this.routes.chargeExportDownload(data.propertyId), "?year=").concat(data.year, "&month=").concat(data.month).concat(data.format ? "&format=".concat(data.format) : ''), _objectSpread({
      responseType: 'blob'
    }, options.cancelToken));
    return resp;
  }
}